import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  constructor(private http: HttpClient) { }

  saveAuditLog(data: any) {
    return this.http.post(environment.ccOpsWebApiUrl + 'api/AuditLog/SaveAuditLog', data);
  }
}
